<section id="solucoes">
    <div class="container">
        <div class="row d-flex justify-content-center align-items-center mt-4 mb-4">
            <div class="col-lg-12">
                <h3 class="text-center">{{ data.TITULO }}</h3>
            </div>
        </div>
        <div class="row d-flex justify-content-between">
            <div class="col-lg-3 d-flex align-items-stretch mb-4" *ngFor="let dado of data.DADOS">
                <div class="card">
                    <div class="card-body">
                        <p class="titulo">{{ dado.TITULO }}</p>
                        <p class="subtitulo">{{ dado.SUBTITULO }}</p>
                        <p class="mt-4">{{ dado.TEXTO }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>